import { Helmet } from 'react-helmet-async';

export default function About() {
  return (
    <div className="bg-white min-h-screen w-full">
      <Helmet>
        <title>Profil | Meubles Karim</title>
      </Helmet>
      
      <main className="w-full bg-white text-black">
        {/* Hero Section */}
        <section className="relative h-[70vh] md:h-screen w-full flex items-center justify-center bg-black overflow-hidden">
          <div className="absolute inset-0 w-full h-full">
            <img 
              src="/usine.jpg" 
              alt="Meubles Karim Usine" 
              className="w-full h-full object-cover object-center opacity-60"
            />
          </div>
          <div className="relative z-10 text-center text-white px-4">
            <h1 className="text-4xl md:text-6xl lg:text-8xl font-bold mb-4 md:mb-8 tracking-wider">
              MEUBLES KARIM
            </h1>
            <p className="text-lg md:text-xl lg:text-2xl font-normal max-w-4xl mx-auto leading-relaxed">
              Histoire d'une excellence tunisienne
            </p>
          </div>
        </section>

        {/* Company Introduction */}
        <section className="py-12 md:py-24 px-4 md:px-6 relative z-10 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-4xl mx-auto text-center">
              <p className="text-base md:text-lg lg:text-xl leading-relaxed text-gray-700 mb-6 md:mb-12">
                Meubles Karim est une entreprise tunisienne, reconnue internationalement comme étant une excellence du «Made in Tunisia» dans le secteur de fabrication des meubles, et interprète du concept de lifestyle à la fois classique et moderne dans les secteurs résidentiel et d'hôtellerie.
              </p>
              <p className="text-sm md:text-base lg:text-lg leading-relaxed text-gray-600">
                L'entreprise a été fondée en 1995 à Hammamet, sur une intuition de Monsieur Abd Karim Chaabani. Le caractère artisanal initial s'est rapidement modifié et, à partir des années 2000, l'entreprise est devenue industrielle par son caractère et sa taille. L'étape suivante appartient à la deuxième génération, qui entame un processus de développement et d'expansion vers les marchés internationaux.
              </p>
            </div>
          </div>
        </section>

        {/* Craftsmanship Gallery */}
        <section className="py-12 md:py-24 px-4 md:px-6 relative z-10 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="space-y-6 md:space-y-8">
              {/* First row: 70% - 30% */}
              <div className="grid grid-cols-1 md:grid-cols-10 gap-4 md:gap-8">
                <div className="md:col-span-7 relative overflow-hidden">
                  <img 
                    src="/aboutRes/IMG-20240319-WA0005.jpg" 
                    alt="Meubles Karim Craftsmanship" 
                    className="w-full h-64 md:h-96 object-cover"
                  />
                </div>
                <div className="md:col-span-3 relative overflow-hidden">
                  <img 
                    src="/aboutRes/IMG-20240319-WA0010.jpg" 
                    alt="Meubles Karim Workshop" 
                    className="w-full h-64 md:h-96 object-cover"
                  />
                </div>
              </div>

              {/* Second row: 30% - 70% */}
              <div className="grid grid-cols-1 md:grid-cols-10 gap-4 md:gap-8">
                <div className="md:col-span-3 relative overflow-hidden order-2 md:order-1">
                  <img 
                    src="/aboutRes/IMG-20240319-WA0007.jpg" 
                    alt="Meubles Karim Production" 
                    className="w-full h-64 md:h-96 object-cover"
                  />
                </div>
                <div className="md:col-span-7 relative overflow-hidden order-1 md:order-2">
                  <img 
                    src="/aboutRes/IMG-20240319-WA0008.jpg" 
                    alt="Meubles Karim Quality" 
                    className="w-full h-64 md:h-96 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Philosophy Section */}
        <section className="w-full relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 min-h-[400px] md:h-[600px]">
            <div className="flex items-center px-6 md:px-12 py-12 md:py-24 bg-white order-2 md:order-1">
              <div>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 md:mb-8 text-gray-900">
                  Notre Philosophie
                </h2>
                <p className="text-base md:text-lg leading-relaxed text-gray-700 mb-4 md:mb-6">
                  La formule-clé de l'identité de Meubles Karim est la pleine expression du concept de "Made in Tunisia" qui mêle aujourd'hui tradition et technologie d'une manière indissoluble.
                </p>
                <p className="text-sm md:text-base leading-relaxed text-gray-600">
                  L'expérience des artisans perfectionne un produit issu des technologies les plus modernes, tandis que l'intelligence des mains offre sensibilité et émotion à la précision industrielle.
                </p>
              </div>
            </div>
            <div className="relative order-1 md:order-2 min-h-[300px] md:min-h-0">
              <img 
                src="gate.jpg" 
                alt="Craftsmanship" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-12 md:py-24 px-6 relative z-20 bg-white">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-8 md:mb-16 text-center text-gray-900">
              Nos Valeurs
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
              <div className="text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-gray-900 rounded-full mx-auto mb-4 md:mb-6 flex items-center justify-center">
                  <span className="text-white text-xl md:text-2xl">✧</span>
                </div>
                <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-gray-900">
                  Excellence
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed px-2">
                  Chaque pièce est conçue avec une attention méticuleuse aux détails et une recherche constante de la perfection.
                </p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-gray-900 rounded-full mx-auto mb-4 md:mb-6 flex items-center justify-center">
                  <span className="text-white text-xl md:text-2xl">♻</span>
                </div>
                <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-gray-900">
                  Durabilité
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed px-2">
                  Nous nous engageons à créer des meubles durables qui respectent l'environnement et perdurent dans le temps.
                </p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-gray-900 rounded-full mx-auto mb-4 md:mb-6 flex items-center justify-center">
                  <span className="text-white text-xl md:text-2xl">🎨</span>
                </div>
                <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-gray-900">
                  Innovation
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed px-2">
                  Nous combinons les techniques traditionnelles avec les innovations modernes pour créer des designs uniques.
                </p>
              </div>
            </div>
          </div>
        </section>

        

        {/* Showroom Section */}
        <section className="w-full relative z-10 bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 min-h-[400px] md:h-[600px]">
            <div className="relative order-1 md:order-1 min-h-[300px] md:min-h-0">
              <img 
                src="showroom.jpg" 
                alt="Meubles Karim Showroom" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex items-center px-6 md:px-12 py-12 md:py-24 bg-white order-2 md:order-2">
              <div>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 md:mb-8 text-gray-900">
                  Notre Showroom
                </h2>
                <p className="text-base md:text-lg leading-relaxed text-gray-700 mb-4 md:mb-6">
                  Découvrez notre espace d'exposition unique où tradition et modernité se rencontrent. Notre showroom de 2000m² présente nos collections dans un environnement soigneusement conçu.
                </p>
                <p className="text-sm md:text-base leading-relaxed text-gray-600 mb-6 md:mb-8">
                  Chaque espace raconte une histoire, chaque pièce témoigne de notre savoir-faire et de notre passion pour l'excellence.
                </p>
                <div className="space-y-3 md:space-y-4">
                  <div className="flex items-center">
                    <span className="w-2 h-2 bg-gray-900 rounded-full mr-3 md:mr-4 flex-shrink-0"></span>
                    <span className="text-sm md:text-base text-gray-700">Visite sur rendez-vous</span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-2 h-2 bg-gray-900 rounded-full mr-3 md:mr-4 flex-shrink-0"></span>
                    <span className="text-sm md:text-base text-gray-700">Conseil personnalisé</span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-2 h-2 bg-gray-900 rounded-full mr-3 md:mr-4 flex-shrink-0"></span>
                    <span className="text-sm md:text-base text-gray-700">Démonstration des finitions</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        
      </main>
    </div>
  );
}
